import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { ConfigService } from '@icc/shared';

@Injectable()
export class PanelHttpInterceptor implements HttpInterceptor {
    constructor(
        private configService: ConfigService,
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.configService.activePanel) {
            req = req.clone({
                setHeaders: {
                    'X-Panel': this.configService.activePanel,
                },
            });
        }

        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 403) {
                    // refresh page to get new token or logout
                    window.location.reload();
                }
                return throwError(() => error);
            })
        )
    }
}